export enum StatusCompanyEnum {
    Active = 1,
    Suspended = 2,
    Delete = 3
  }